import React, { useRef } from 'react'
import { StyleSheet } from 'react-native'

import { publishEvent } from '@zet/analytics'
import { Stack } from '@zet/design-system'
import { DEVICE_WIDTH } from '@zet/utils/Constants'
import Carousel from 'react-native-reanimated-carousel'

import { BannerResponseData } from '../../api/brands/types'
import BannerCard from './bannerCard'

const BannerCarousel = ({
  data,
}: {
  data: BannerResponseData[] | undefined
}) => {
  const IS_SINGLE_ITEM = data?.length === 1
  const SPACING = IS_SINGLE_ITEM ? 0 : 16
  const CAROUSEL_WIDTH = DEVICE_WIDTH - 32
  const ITEM_WIDTH = CAROUSEL_WIDTH - SPACING
  const viewedObj = useRef<Record<string, boolean>>({})
  const onSnapToItem = (index: number) => {
    const eventName = data?.[index]?.trackEventPayload?.item_name
    if (eventName && !viewedObj?.current?.[eventName]) {
      viewedObj.current[eventName] = true
      publishEvent('banner_view', {
        item_name: eventName,
        screen_name: 'product_listing',
      })
    }
  }
  if (!data?.length) return <></>

  return (
    <Stack className="mb-4">
      <Carousel
        loop={!IS_SINGLE_ITEM}
        width={CAROUSEL_WIDTH}
        onSnapToItem={onSnapToItem}
        height={(CAROUSEL_WIDTH * 8.9) / 16}
        autoPlayInterval={3000}
        autoPlay={data?.length > 0}
        style={styles.carousel}
        enabled={!IS_SINGLE_ITEM}
        data={data}
        scrollAnimationDuration={1000}
        renderItem={({ item }) => {
          return <BannerCard bannerData={item} width={ITEM_WIDTH} />
        }}
        onConfigurePanGesture={(g) => {
          'worklet'
          g.activeOffsetX([-10, 10])
        }}
      />
    </Stack>
  )
}

export { BannerCarousel }
const styles = StyleSheet.create({
  carousel: {
    width: '100%',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 10,
  },
})
